"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppBarNotificationList = void 0;
const react_1 = __importStar(require("react"));
const react_window_1 = require("react-window");
const NotificationMessage_1 = require("../NotificationMessage/NotificationMessage");
const constants_1 = require("../../helpers/constants");
const getNotificationListMaxHeight_1 = require("../../helpers/getNotificationListMaxHeight");
const getVirtualizedListHeight_1 = require("../../helpers/getVirtualizedListHeight");
exports.AppBarNotificationList = (0, react_1.memo)(({ messages = [], virtualization, isFooterEnabled }) => {
    const [variableSizeListHeight, setVariableSizeListHeight] = (0, react_1.useState)(0);
    const [variableSizeListMaxHeight, setVariableSizeListMaxHeight] = (0, react_1.useState)('');
    const listRef = (0, react_1.useRef)(null);
    const listWrapperRef = (0, react_1.useRef)(null);
    const rowsHeight = (0, react_1.useRef)({});
    const messagesList = (0, react_1.useMemo)(() => messages
        .map(({ title, textIcon, titleIcon, text, onCloseClick, id, read, render }, index) => {
        if (typeof render === 'function') {
            const customElement = render({
                title,
                textIcon,
                titleIcon,
                text,
                onCloseClick,
                id
            });
            if (!customElement) {
                return null;
            }
            return react_1.default.cloneElement(customElement, {
                key: `${id || `idx_${index}`}`,
                ['data-selector-id']: `notification-msg-${id || `idx_${index}`}`
            });
        }
        const key = `${id || `idx_${index}`}`;
        const testId = `notification-msg-${id || `idx_${index}`}`;
        return (react_1.default.createElement(NotificationMessage_1.NotificationMessage, { testId: testId, key: key, read: read, title: title, titleIcon: titleIcon, textIcon: textIcon, text: text, hasBorder: Boolean(index), onCloseClick: onCloseClick }));
    })
        .filter(Boolean), [messages]);
    const getItemSize = (0, react_1.useCallback)((index) => {
        return rowsHeight.current[index] || 51;
    }, []);
    const variableSizeListWidth = (0, react_1.useMemo)(() => {
        if (virtualization && virtualization.width) {
            return virtualization.width > constants_1.APP_BAR_NOTIFICATION_MAX_WIDTH_POPOVER
                ? constants_1.APP_BAR_NOTIFICATION_MAX_WIDTH_POPOVER
                : virtualization === null || virtualization === void 0 ? void 0 : virtualization.width;
        }
        return constants_1.APP_BAR_NOTIFICATION_MAX_WIDTH_POPOVER;
    }, [virtualization]);
    const RenderMessage = (0, react_1.memo)(function RenderMessage({ style, data, index }) {
        const messageRef = (0, react_1.useRef)(null);
        (0, react_1.useEffect)(() => {
            var _a;
            if (messageRef && messageRef.current) {
                rowsHeight.current[index] = messageRef.current.clientHeight;
                (_a = listRef.current) === null || _a === void 0 ? void 0 : _a.resetAfterIndex(index);
                const rowsHeightLength = Object.keys(rowsHeight.current).length;
                const messagesListLength = messagesList.length;
                if (messagesListLength < rowsHeightLength) {
                    const difference = rowsHeightLength - messagesListLength;
                    for (let i = 0; i < difference; i++) {
                        const keys = Object.keys(rowsHeight.current);
                        const lastKey = keys[keys.length - 1];
                        delete rowsHeight.current[lastKey];
                    }
                }
                const sum = (0, getVirtualizedListHeight_1.getVirtualizedListHeight)(rowsHeight.current);
                const maxHeight = (0, getNotificationListMaxHeight_1.getNotificationListMaxHeight)(isFooterEnabled);
                const newHeight = Math.min(sum, maxHeight);
                if (newHeight !== variableSizeListHeight) {
                    requestAnimationFrame(() => {
                        setVariableSizeListHeight(newHeight);
                    });
                }
            }
        }, [index]);
        return (react_1.default.createElement("div", { style: style },
            react_1.default.createElement("div", { ref: messageRef }, data[index])));
    });
    (0, react_1.useEffect)(() => {
        var _a;
        const listTop = ((_a = listWrapperRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().top) || 0;
        const footerHeight = isFooterEnabled ? constants_1.APP_BAR_NOTIFICATION_FOOTER_HEIGHT : 0;
        const maxHeightStyle = `calc(100vh - (${listTop + 1}px + ${footerHeight}px))`;
        setVariableSizeListMaxHeight(maxHeightStyle);
    }, [isFooterEnabled]);
    if (!(virtualization === null || virtualization === void 0 ? void 0 : virtualization.enabled)) {
        return react_1.default.createElement(react_1.default.Fragment, null, messagesList);
    }
    return (react_1.default.createElement(react_window_1.VariableSizeList, { ref: listRef, outerRef: listWrapperRef, itemCount: messagesList.length, itemSize: getItemSize, itemData: messagesList, height: variableSizeListHeight, style: {
            maxHeight: variableSizeListMaxHeight
        }, width: variableSizeListWidth, className: "notifications-virtualized-list" }, RenderMessage));
});
exports.AppBarNotificationList.displayName = 'AppBarNotificationList';
//# sourceMappingURL=AppBarNotificationList.js.map